import React, { useState, useEffect } from "react";
import { Row, Col, Tabs, Badge } from "antd";
//import moment from "moment";
//import { useDispatch } from "react-redux";
//import { figurenames, figures } from "../../constants";


// Styles
import { Wrapper } from "./styles";

import Colors from '../../theme/colors'

// Hooks
import useManufacturingOrder from '../../hooks/useManufacturingOrder';

import RenderFurnace from './furnace';
import RenderQuenching from './quenching';
import RenderTempered from './tempered';

//import multilanguage library
import { useTranslation } from 'react-i18next'


const { TabPane } = Tabs;

const INITIAL_QUENCHING = {
  bath_type: "water",
  bath_temperature: 60,
  agitation_level: 1
}

const RenderControlProcess = ({ changeTitle }) => {
  const [countFurnace, setCountFurnace] = useState(0);
  const [countQuenching, setCountQuenching] = useState(0);
  const [countTempered, setCountTempered] = useState(0);


  const [quenchingStatus, /*setQuenchingStatus*/] = useState(INITIAL_QUENCHING);


  const { manufacturingOrder } = useManufacturingOrder();

  //To translate text
  const { t } = useTranslation();

  useEffect(() => {
    changeTitle && changeTitle("control_process");
  }, [changeTitle]);

  useEffect(() => {
    const filtered = manufacturingOrder.filter((order, i) => order.desing);
    let nFurnace = 0, nQuenching = 0, nTempered = 0;
    filtered.forEach((order, i) => {
      order.pieces.forEach((piece, x) => {
        if(piece.furnace && piece.furnace.start && !piece.furnace.end) nFurnace++;
        if(piece.quenching && piece.quenching.start && !piece.quenching.end) nQuenching++;
        if(piece.tempered && piece.tempered.start && !piece.tempered.end) nTempered++;
      });
    });
    setCountFurnace(nFurnace)
    setCountQuenching(nQuenching)
    setCountTempered(nTempered)
  }, [manufacturingOrder]);

  return (
    <Wrapper>
        <Row style={{ margin: 0 }} gutter={[16, 16]}>
            <Col xl={24} lg={24} md={24}>
              <Tabs defaultActiveKey="1" >
                <TabPane tab={<span>{t('phase.furnace')} <Badge count={countFurnace} style={{ backgroundColor: Colors.primary }} /></span>} key="1">
                  <RenderFurnace quenchingStatus={quenchingStatus} />
                </TabPane>
                <TabPane tab={<span>{t('phase.quenching')} <Badge count={countQuenching} style={{ backgroundColor: Colors.primary }} /></span>} key="2">
                  <RenderQuenching quenchingStatus={quenchingStatus} />
                </TabPane>
                <TabPane tab={<span>{t('phase.tempered')} <Badge count={countTempered} style={{ backgroundColor: Colors.primary }} /></span>} key="3">
                  <RenderTempered />
                </TabPane>
              </Tabs>
            </Col>
        </Row>
    </Wrapper>
  );
};
export default RenderControlProcess;
